export class UserToken {
  public accessToken: string;
  public idToken: string;
  public refreshToken: string;

  set id_token(token:string) {
    this.idToken = token;
  }
  get id_token() {
    return this.idToken;
  }

  set access_token(token:string) {
    this.accessToken = token;
  }
  get access_token() {
    return this.accessToken;
  }

  set refresh_token(token:string) {
    this.refreshToken = token;
  }
  get refresh_token() {
    return this.refreshToken;
  }

  public static parse(tokenObject:any): UserToken {
    let token = new UserToken();
    token.accessToken = tokenObject.accessToken || tokenObject.access_token;
    token.idToken = tokenObject.idToken || tokenObject.id_token;
    token.refreshToken = tokenObject.refreshToken || tokenObject.refresh_token;
    return token;
  }

  constructor() {
    this.accessToken = undefined;
    this.refreshToken = undefined;
    this.idToken = undefined;
  }
}
